(function(){
var cfg=document.getElementById('cfg'); if(!cfg) return;
var HANDLE=cfg.getAttribute('data-handle');
var MAX=3;
var IDS={
solo:{white:58885521473867,pink:58885521506635,blue:58885521539403},
duet:{white:58885521572171,pink:58885521604939,blue:58885521637707}
};
var KIND={solo:{name:'Solo',desc:'1 mikrofon'},duet:{name:'Duet',desc:'2 mikrofony'}};
var COLORS=[{k:'white',n:'Biały',c:'#f4f1ea'},{k:'pink',n:'Różowy',c:'#ffb6d3'},{k:'blue',n:'Niebieski',c:'#8cc9ff'}];
var COLORNAME={}; COLORS.forEach(function(c){COLORNAME[c.k]=c.n;});
var IMG={};
try{ IMG=JSON.parse(document.getElementById('ds-imgs').textContent)||{}; }catch(e){ IMG={}; }
var PRICE={}; var AVAIL={}; var CMP={};
Object.keys(IDS).forEach(function(k){
var p=k==='solo'?119.99:149.99;
var cp=k==='solo'?159.99:199.99;
Object.keys(IDS[k]).forEach(function(c){PRICE[IDS[k][c]]=p;CMP[IDS[k][c]]=cp;AVAIL[IDS[k][c]]=true;});
});
var items=[{kind:'duet',color:'white'}];
var elItems=document.getElementById('items'), elTotal=document.getElementById('total'), elMsg=document.getElementById('msg'),
elSum=document.getElementById('sum'), elOld=document.getElementById('old'), elSave=document.getElementById('save'),
elTiers=document.getElementById('tiers'), bAdd=document.getElementById('addBtn');
var DISC={1:0,2:0,3:0};
Array.prototype.forEach.call(elTiers.querySelectorAll('button'),function(b){
DISC[+b.getAttribute('data-n')]=parseFloat(b.getAttribute('data-d'))||0;
});
function money(v){return v.toLocaleString('pl-PL',{minimumFractionDigits:2,maximumFractionDigits:2})+' zł';}
function disc(p,d){return Math.round(p*(1-d)*100)/100;}
function vid(it){return IDS[it.kind][it.color];}
function label(it){return KIND[it.kind].name+' · '+COLORNAME[it.color];}
function minPrice(){var m=1e9;for(var k in PRICE){if(PRICE[k]<m)m=PRICE[k];}return m;}
function cmpOf(id){var c=CMP[id],p=PRICE[id];return (c&&c>p)?c:0;}
function setCount(n){
n=Math.max(1,Math.min(MAX,n));
while(items.length<n){ var last=items[items.length-1]; items.push({kind:last.kind,color:last.color}); }
while(items.length>n){ items.pop(); }
elMsg.textContent=''; render();
}
function render(){
var n=items.length, d=DISC[n]||0;
Array.prototype.forEach.call(elTiers.querySelectorAll('button'),function(b){
var tn=+b.getAttribute('data-n'), td=DISC[tn]||0, tp=b.querySelector('.tp');
b.setAttribute('aria-pressed',String(tn===n));
if(tp){ tp.innerHTML=td>0?'od <s>'+money(minPrice())+'</s> '+money(disc(minPrice(),td))+'/szt.':'od '+money(minPrice())+'/szt.'; }
});
var sub=0,total=0,subCmp=0, html='<div class="items-list">';
items.forEach(function(it,i){
var id=vid(it), price=PRICE[id], img=IMG[id], cp=cmpOf(id); sub+=price; total+=disc(price,d); subCmp+=(cp||price);
var priceHtml=d>0?'<s>'+money(price)+'</s> '+money(disc(price,d)):(cp?'<s>'+money(cp)+'</s> '+money(price):money(price));
html+='<div class="item" data-i="'+i+'"><div class="item-body"><div class="item-head"><h3>'+(n>1?'Sztuka '+(i+1):'Twój zestaw')+'</h3><span class="ip">'+priceHtml+'</span></div>'+
'<div class="opt-label">Wersja</div><div class="seg">';
Object.keys(KIND).forEach(function(k){
var kid=IDS[k][it.color], p=PRICE[kid], kc=cmpOf(kid);
var ph=d>0?'<s>'+money(p)+'</s> '+money(disc(p,d)):(kc?'<s>'+money(kc)+'</s> '+money(p):money(p));
html+='<button type="button" data-kind="'+k+'" aria-pressed="'+(it.kind===k)+'">'+KIND[k].name+' · '+KIND[k].desc+'<small>'+ph+'</small></button>';
});
html+='</div><div class="opt-label">Kolor</div><div class="sw">';
COLORS.forEach(function(c){
html+='<button type="button" data-color="'+c.k+'" aria-pressed="'+(it.color===c.k)+'"><i style="background:'+c.c+'"></i>'+c.n+'</button>';
});
html+='</div></div>';
if(img){ html+='<div class="item-photo"><img src="'+img+'" alt="'+label(it)+'" width="300" height="300"><span class="photo-tag">'+label(it)+'</span></div>'; }
html+='</div>';
});
html+='</div>';
elItems.innerHTML=html;
elTotal.textContent=money(total);
var oldV=d>0?sub:subCmp, hasOld=oldV>total+0.001;
if(elOld){ elOld.textContent=hasOld?money(oldV):''; }
if(elSave){ elSave.textContent=hasOld?'Oszczędzasz '+money(oldV-total)+' (−'+Math.round((oldV-total)/oldV*100)+'%)':''; }
if(elSum){ elSum.textContent=items.map(label).join(' + '); }
}
elTiers.addEventListener('click',function(e){
var b=e.target.closest('button'); if(!b) return;
setCount(+b.getAttribute('data-n'));
});
elItems.addEventListener('click',function(e){
var b=e.target.closest('button'); if(!b) return;
var row=b.closest('.item'); if(!row) return;
var it=items[+row.getAttribute('data-i')];
if(b.hasAttribute('data-kind')) it.kind=b.getAttribute('data-kind');
if(b.hasAttribute('data-color')) it.color=b.getAttribute('data-color');
elMsg.textContent=''; render();
});
bAdd.addEventListener('click',function(){
var qty={}; items.forEach(function(it){var id=vid(it); qty[id]=(qty[id]||0)+1;});
for(var id in qty){ if(AVAIL[id]===false){elMsg.textContent='Jeden z wybranych wariantów jest chwilowo niedostępny. Wybierz inny kolor lub wersję.';return;} }
var payload={items:Object.keys(qty).map(function(id){return {id:+id,quantity:qty[id]};})};
bAdd.disabled=true; elMsg.textContent='Dodaję do koszyka…';
fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)})
.then(function(r){ if(!r.ok) throw new Error('cart'); return r.json(); })
.then(function(){ window.location.href='/cart'; })
.catch(function(){ bAdd.disabled=false; elMsg.textContent='Nie udało się dodać do koszyka. Spróbuj ponownie.'; });
});
fetch('/products/'+HANDLE+'.js',{headers:{'Accept':'application/json'}})
.then(function(r){ if(!r.ok) throw new Error('p'); return r.json(); })
.then(function(p){
(p.variants||[]).forEach(function(v){
if(PRICE.hasOwnProperty(v.id)){ PRICE[v.id]=v.price/100; CMP[v.id]=v.compare_at_price?v.compare_at_price/100:0; AVAIL[v.id]=!!v.available; }
});
render();
}).catch(function(){});
render();
})();